<template>
  <a-modal :class="[modalClass, simpleClass]" :visible="visible" v-bind="$props" :footer="null" :destroyOnClose='true'
    :bodyStyle="{ padding: 10 }" @ok="handleOk" @cancel="handleCancel" :mask='true' :maskClosable='false'>
    <div :style="bodyStyle">
      <slot></slot>
    </div>
    <div class="ant-modal-footer relative" style="display:none;">
      <slot name="footer"></slot>
    </div>
    <div v-if="!title && title !== ''" slot="title">
      <slot name="title"></slot>
    </div>
  </a-modal>
</template>

<script>
import props from './props.js'
var mouseDownX = 0
var mouseDownY = 0
var deltaX = 0
var deltaY = 0
var sumX = 0
var sumY = 0
var startTop = 0

var header = null
var contain = null
var modalContent = null

var onmousedown = false
export default {
  name: 'DragModal',
  mixins: [props],
  props: {
    // 容器的类名
    modalClass: {
      type: String,
      default: () => {
        return 'modal-box'
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    title: {
      type: String,
      default: () => {
        return undefined
      }
    },
    width: {
      type: String,
      default: () => {
        return '70%'
      }
    },
    footer: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    simpleClass() {
      return Math.random().toString(36).substring(2)
    }
  },
  watch: {
    visible() {
      this.$nextTick(() => {
        this.initialEvent(this.visible)
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initialEvent(this.visible)
    })
  },
  created() { },
  beforeDestroy() {
    this.removeMove()
    window.removeEventListener('mouseup', this.removeUp, false)
  },
  methods: {
    handleOk(e) {
      this.resetNum()
      this.$emit('ok', e)
    },
    handleCancel(e) {
      this.resetNum()
      this.$emit('cancel', e)
    },
    resetNum() {
      mouseDownX = 0
      mouseDownY = 0
      deltaX = 0
      deltaY = 0
      sumX = 0
      sumY = 0
    },
    handleMove(event) {
      const delta1X = event.pageX - mouseDownX
      const delta1Y = event.pageY - mouseDownY

      deltaX = delta1X
      deltaY = delta1Y

      // 拖拽后的顶部位置
      const newTop = startTop + delta1Y

      // Y 位移
      let newY = sumY + delta1Y

      // 只限制顶部
      if (newTop < 0) {
        newY = sumY - startTop
        deltaY = -startTop
      }

      modalContent.style.transform = `translate(${delta1X + sumX}px, ${newY}px)`
    },
    initialEvent(visible) {
      if (visible) {
        setTimeout(() => {
          window.removeEventListener('mouseup', this.removeUp, false)
          contain = document.getElementsByClassName(this.simpleClass)[0]
          header = contain.getElementsByClassName('ant-modal-header')[0]
          modalContent = contain.getElementsByClassName('ant-modal-content')[0]
          modalContent.style.left = 0
          header.style.cursor = 'all-scroll'

          // contain.onmousedown = (e) => {
          header.onmousedown = (e) => {
            onmousedown = true

            mouseDownX = e.pageX
            mouseDownY = e.pageY

            // 记录开始拖拽时弹窗距离顶部的位置
            startTop = modalContent.getBoundingClientRect().top

            document.body.onselectstart = () => false

            window.addEventListener('mousemove', this.handleMove, false)
          }

          window.addEventListener('mouseup', this.removeUp, false)
        }, 0)
      }
    },
    removeMove() {
      window.removeEventListener('mousemove', this.handleMove, false)
    },
    removeUp(e) {
      document.body.onselectstart = () => true
      if (onmousedown && !(e.pageX === mouseDownX && e.pageY === mouseDownY)) {
        onmousedown = false
        sumX = sumX + deltaX
        sumY = sumY + deltaY
      }

      this.removeMove()
      //  this.checkMove()
    }
  }
}
</script>
<style lang="less">
.ant-modal-close-x {
  background: #1d8bfe;
  color: #fff;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 0 4px 0 0;
}

.ant-modal-header {
  height: 64px;

  .ant-modal-title {
    line-height: 30px;
    color: #0e2949;
    font-size: 1.25rem;
  }
}
</style>